// Font awesome
import { faEye } from "@fortawesome/free-solid-svg-icons";
// Fhir front library
import { SearchableTable } from "@fyrstain/fhir-front-library";
// Translation
import i18n from "i18next";
// React
import { FunctionComponent, useCallback } from "react";
// Navigation
import { useNavigate } from "react-router-dom";
// Component
import AcesoPage from "src/components/AcesoPage/AcesoPage";
// Fhir
import { Patient } from "fhir/r4";

const PatientsList: FunctionComponent = () => {

    //////////////////////////////
    //        Navigation        //
    //////////////////////////////

    const navigate = useNavigate();

    const onDetails = useCallback((id: string) => {
        navigate("/PatientsViewer/" + id);
    }, [navigate]);

    //////////////////////////////
    //           Error          //
    //////////////////////////////

    const onError = useCallback((error?: unknown) => {
        navigate("/Error", { state: { error } });
    }, [navigate]);

    //////////////////////////////
    //         Functions        //
    //////////////////////////////

    /**
    * Get lastname Response to populate the table.
    * 
    * @param patient    the parameters to the Bundle resource.
    */
    function getLastname(patient: Patient): string {
        const familyName = patient.name?.[0]?.family;
        return familyName ? familyName : 'N/A';
    }

    /**
    * Get firstname Response to populate the table.
    * 
    * @param patient    the parameters to the Bundle resource.
    */
    function getFirstname(patient: Patient): string {
        const givenName = patient.name?.[0]?.given?.[0];
        return givenName ? givenName : 'N/A';
    }

    //////////////////////////////
    //          Content         //
    //////////////////////////////

    return (
        <AcesoPage titleKey='title.patientslist' needsLogin={true} >
            <SearchableTable
                searchCriteriaProperties={{
                    title: i18n.t('title.searchcriteria'),
                    submitButtonLabel: i18n.t('button.search'),
                    resetButtonLabel: i18n.t('button.reset'),
                    language: i18n.t,
                    fixedParameters: {
                        _elements: "id,name,birthDate",
                        _sort: "-_lastUpdated",
                    },
                    inputs: [
                        {
                            label: i18n.t('label.lastname'),
                            type: "text",
                            searchParamsName: "family",
                        },
                        {
                            label: i18n.t('label.firstname'),
                            type: "text",
                            searchParamsName: "given",
                        },
                        {
                            label: i18n.t('label.birthdate'),
                            type: "date",
                            searchParamsName: "birthdate",
                        },
                    ],
                }}
                paginatedTableProperties={{
                    columns: [
                        {
                            header: i18n.t('label.lastname'),
                            dataField: "lastname",
                            width: "30%",
                        },
                        {
                            header: i18n.t('label.firstname'),
                            dataField: "firstname",
                            width: "30%",
                        },
                        {
                            header: i18n.t('label.birthdate'),
                            dataField: "birthdate",
                            width: "30%",
                        },
                    ],
                    action: [
                        {
                            icon: faEye,
                            onClick: onDetails,
                        },
                    ],
                    mapResourceToData: (resource: any) => {
                        return {
                            lastname: getLastname(resource),
                            firstname: getFirstname(resource),
                            birthdate: resource.birthDate ?? 'N/A',
                            id: resource.id,
                        }
                    },
                    searchProperties: {
                        serverUrl: process.env.REACT_APP_FHIR_URL as string,
                        resourceType: 'Patient',
                    },
                    onError: onError,
                }}
            />
        </AcesoPage>
    );
};

export default PatientsList;
